<div class="widget-container widget-quarter" style="margin-left: 2em; margin-bottom:2em" *ngFor="let icon of w3Icons">
  <a href="{{icon.link}}" target="_blank" rel="noopener">
    <img alt="widgets" class="lazyload" data-src="{{icon.imageURL}}" [style.width.px]="icon.size" [style.height.px]="icon.size"
      [style.marginLeft]="icon.margin" [style.marginTop]="icon.margintop"> </a>
</div>